import { makeStyles } from '@mui/styles';

interface BackToTopStylesProps {
  isWindowScroll: boolean;
  wrapperHeight: number;
}
export const useStyles = makeStyles((theme) => ({
  innerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  wrapper: {
    alignItems: 'end',
    bottom: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: ({ isWindowScroll }: BackToTopStylesProps) =>
      isWindowScroll ? theme.spacing(2) : 0,
    marginRight: ({ isWindowScroll }: BackToTopStylesProps) =>
      isWindowScroll ? theme.spacing(2) : theme.spacing(4),
    marginTop: ({ isWindowScroll, wrapperHeight }: BackToTopStylesProps) =>
      isWindowScroll ? 0 : `-${wrapperHeight}px`,

    pointerEvents: 'none',
    position: ({ isWindowScroll }: BackToTopStylesProps) =>
      isWindowScroll ? 'fixed' : 'sticky',
    right: 0,

    '& > div': {
      pointerEvents: 'all',
    },
  },
  button: {
    backgroundColor: theme.palette.grey[200],
    borderRadius: theme.shape.borderRadius,
    opacity: '.35',
    pointerEvents: 'none',
    transition: 'opacity .25s',
  },
  bottomIsShown: {
    opacity: '1',
    pointerEvents: 'initial',
  },
  topIsShown: {
    opacity: '1',
    pointerEvents: 'initial',
  },
}));
